/* eslint-disable react/jsx-one-expression-per-line */
import { useMemo, useState } from "react";
import Button from "components/atoms/buttons/Button";
import ClaimResponseModel from "./claimResponseModal";

interface IProps {
  magnetStatus: MagnetStates;
  imageSrc: string;
  name: string;
  totalSupply: string;
  availableSupply: string;
  description: string;
  handlePublishMagnet: () => void;
  total_claim_form_responses: number;
  magnet_id: string;
}

function MagnetOverviewCard({
  magnetStatus,
  imageSrc,
  name,
  totalSupply,
  availableSupply,
  description,
  handlePublishMagnet,
  total_claim_form_responses,
  magnet_id,
}: IProps) {
  const [isClaimResponseModelOpen, setClaimResponseModel] = useState(false);

  const publishCTAText = useMemo(() => {
    switch (magnetStatus) {
      case 0:
        return "PUBLISH";
      case 1:
        return "PUBLISHING";
      default:
        return "PUBLISHED";
    }
  }, [magnetStatus]);

  return (
    <div className="text-white">
      <div className="flex items-center justify-between">
        <section className="font-sora text-xs font-medium text-white underline 2xl:text-sm">CREATION DETAILS</section>
        {total_claim_form_responses > 0 && (
          <div className="">
            <Button
              variant="whiteSolid"
              additionalClasses=" text-xxs xl:text-base md:text-base md:px-2 md:py-1 2xl:text-xxs xl:px-2 xl:py-1 2xl:px-3 2xl:py-2 "
              text="CLAIM RESPONSES"
              onClick={() => setClaimResponseModel(true)}
            />
            {isClaimResponseModelOpen && (
              <ClaimResponseModel
                magnet_id={magnet_id}
                open={isClaimResponseModelOpen}
                onClose={() => setClaimResponseModel(false)}
              />
            )}
          </div>
        )}
      </div>
      <div className="mt-4 flex gap-5 2xl:mt-6 2xl:gap-7">
        <img
          src={imageSrc}
          className="aspect-1 w-64 basis-72 rounded-xl border-2 border-white border-opacity-5 object-cover shadow-md 2xl:h-72 2xl:w-72"
          alt={name}
        />

        <div className="flex w-full flex-col">
          <p
            className="max-w-xl truncate font-sora text-2xl font-semibold
            2xl:max-w-2xl 2xl:text-3xl 4xl:text-4xl"
          >
            {name}
          </p>
          <section
            className="line-clamp-8 mt-1 w-1/2 font-satoshi text-xs font-normal leading-6
           opacity-60 2xl:text-sm 4xl:text-lg"
          >
            {description}
          </section>
          <div className="mt-auto flex w-full items-end justify-between">
            <div>
              <p className="mb-1 font-satoshi text-xs font-450 leading-5 2xl:text-sm">Total Remaining Supply</p>
              <span className="font-satoshi text-xl font-bold sm:text-xl md:text-2xl 2xl:text-3xl">
                {availableSupply}
              </span>
              <span className="font-satoshi text-xs font-bold sm:text-xs md:text-sm 2xl:text-lg">/{totalSupply}</span>
            </div>
            <Button
              onClick={handlePublishMagnet}
              additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
              text={publishCTAText}
              disabled={magnetStatus !== 0}
              variant="magnetiqSolid"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MagnetOverviewCard;
